import React from "react";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import logo from "../resourcess/Products/SRC Logo.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-col footer-brand">
          <img src={logo} alt="SRC Corporation" className="footer-logo" />
          <p className="footer-copy">
SRC Corporation supplies premium chilli and spice products with consistent quality, competitive pricing, and reliable global delivery.
          </p>
        </div>
        <div className="footer-col">
          <h4 className="footer-title">Quick Links</h4>
          <ul className="footer-list">
            <li>
              <a href="#hero">Home</a>
            </li>
            <li>
              <a href="#about">About</a>
            </li>
            <li>
              <a href="#products">Products</a>
            </li>
            <li>
              <a href="#process">Process</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </div>
        <div className="footer-col footer-contact">
          <p className="footer-contact-item">
            <span className="footer-contact-label">
              <FaPhoneAlt aria-hidden="true" /> Phone
            </span>
            <span>+91 98494 24568 &nbsp;&nbsp; +91 88850 24568</span>
            <span>+91 96525 02121 &nbsp;&nbsp; +49 176 61749674</span>
          </p>
          <p className="footer-contact-item">
            <span className="footer-contact-label">
              <FaEnvelope aria-hidden="true" /> Email
            </span>
            <a href="mailto:srccorporation2112@gmail.com" className="footer-mail-link">
              srccorporation2112@gmail.com
            </a>
            <a href="mailto:sheshankchigumalla@gmail.com" className="footer-mail-link">
              sheshankchigumalla@gmail.com
            </a>
          </p>
          <p className="footer-contact-item">
            <span className="footer-contact-label">
              <FaMapMarkerAlt aria-hidden="true" /> Location
            </span>
            <span>
Shop No-112, 1st Floor, 16-10-1, Malakpet Gunj, Sri Krupa Market, Hyderabad, Telangana 500036, India
            </span>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 SRC Corporation | All Rights Reserved</p>
        <p>
          Designed &amp; Developed by {" "}
          <a
            href="http://instagram.com/grooit.official/"
            target="_blank"
            rel="noreferrer"
          >
            <strong>Grooit Media</strong>
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
